<template>
  <div class="account-icon"
       :class="{'bank':isBank}"
       v-html="computedIcon">
  </div>
</template>

<script>
import {icons, groups} from "@/components/icons/MKIcons/icons";

export default {
  name: "MKIcons",
  props: {
    icon: {
      type: String,
      required: true
    }
  },
  computed: {
    computedIcon() {
      return icons[this.icon]
    },
    isBank() {
      return groups.filter(group => group.title === 'BANKS')[0].icons.indexOf(this.icon) !== -1;
    }
  }
}
</script>

<style lang="scss">
.account-icon {
  @apply inline-flex items-center justify-center rounded-full;
  svg {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    width: 1em;
    vertical-align: -0.125em;
    overflow: visible;
  }

  &.bank svg {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    overflow: hidden;
  }
}
</style>